import { render, staticRenderFns } from "./GlaxiFooter.vue?vue&type=template&id=6428aeb8&"
import script from "./GlaxiFooter.vue?vue&type=script&lang=js&"
export * from "./GlaxiFooter.vue?vue&type=script&lang=js&"
import style0 from "./GlaxiFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports